import { componentFactoryOf } from 'vue-tsx-support';

import { injectStylesMixin } from '../../../mixins/inject-styles';
import { JtnUiTypography } from '../../jtn-ui-typography';

import styles from './jtn-ui-record-tags.styles.scss?module';

interface Events {
  onTagClicked: {
    event: Event;
    url: string;
    name: string;
  };
}

type Tag = {
  name: string;
  url?: string;
};

export default componentFactoryOf<Events>()
  .mixin(injectStylesMixin(styles))
  .create({
    name: 'JtnUiRecordTags',
    components: {
      JtnUiTypography
    },
    props: {
      tags: {
        type: Array as () => Tag[],
        default() {
          return [];
        }
      }
    },
    render() {
      const attributes = {
        attrs: this.$attrs,
        on: this.$listeners
      };

      return (
        <div class={styles.recordTags} {...attributes}>
          {this.tags.map((tag: Tag, index: number) => (
            <jtn-ui-typography
              key={index}
              class={styles.tag}
              tag="a"
              type="font-vijet-type-3"
              href={tag.url || ''}
              title={tag.name}
              onClick={(event: Event) => {
                this.$emit('tagClicked', { event, url: tag.url, name: tag.name });
              }}
            >
              <span domPropsInnerHTML={tag.name} />
            </jtn-ui-typography>
          ))}
        </div>
      );
    }
  });
